export default (theme) => ({
  inputLabel: {
    color: "rgba(0, 0, 0)",
    paddingBottom: 10,
    fontSize: 13,
  },
});
